import React, { useState, useEffect } from "react";
import { Button, Modal } from "semantic-ui-react";
import PropTypes from "prop-types";
// Components
import IkTable from "@Components/IkTable";
// redux
import genericAction from "@Actions/generic";
import { connect } from "react-redux";
// Utils
import dataHandler from "@Utils/dataHandler";
// Styles
import styles from "./styles.module.css";

const Hashtag = ({ onClose, dispatch }) => {
	const [hashtag, setHashtag] = useState([]);
	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setFilteredCount] = useState([]);
	const defaultParams = { rows: 5, page: 1, orderKey: "id", orderDir: "desc" };

	useEffect(() => {
		(async () => {
			const hashtagPromise = await dataHandler({
				dispatch,
				url: "hashtag",
				params: { rows: 5, page: 1, orderKey: "id", orderDir: "desc" },
			});
			setFilteredCount(hashtagPromise.count);
			setFilteredItems(hashtagPromise.items);
		})();
	}, []);

	// save handlers
	const handlerSaved = async () => {
		await dispatch(genericAction({ method: "post", route: "hashtag", body: hashtag }));
		onClose();
	};

	// Table Handlers
	const handlerData = async (params) => {
		const data = await dataHandler({ dispatch, url: "quickAnswers", params });
		setFilteredItems(data.items);
		setFilteredCount(data.count);
	};

	const handleButtom = (name, item) => {
		if (name === "onClick ") setHashtag(item);
	};

	return (
		<Modal size="Large" open closeIcon onClose={onClose} dimmer="blurring">
			<Modal.Header className="modalHeader">
				<div>{" Hashtag"}</div>
			</Modal.Header>
			<Modal.Content scrolling>
				<div>
					<IkTable
						data={filteredItems}
						columns={[
							{
								label: "Acciones",
								action: [
									{ content: "trash", color: "#b43333", onClick: "Eraser", type: "icon" },
									{ content: "edit", color: "#3f7ea3", onClick: "Edit", type: "icon" },
								],
								dataPosition: "center",
								width: 1,
								canFilter: false,
								canSort: false,
							},
							{
								label: "ID",
								key: "id",
								format: "string",
								dataPosition: "center",

								width: 1,
								canFilter: true,
								canSort: true,
								canPrint: true,
								canExcel: true,
								sortKey: null,
							},
							{
								label: "Hashtag",
								dataPosition: "center",
								key: "hashtag",
								format: "string",
								width: 1,
								canFilter: true,
								canSort: true,
								canPrint: true,
								canExcel: true,
								sortKey: null,
							},
							{
								label: "Formato",
								key: "type",
								dataPosition: "center",
								format: "array",
								width: 1,
								canFilter: true,
								canSort: true,
								canPrint: true,
								canExcel: true,
								sortKey: null,
							},
							{
								label: "Mensaje",
								key: "text",
								format: "string",
								stringLength: 45,
								width: 9,

								canFilter: true,
								canSort: true,
								canPrint: true,
								canExcel: true,
								sortKey: null,
							},
							{
								label: "Estado",
								key: "isActive",
								format: "boolean",
								dataPosition: "center",
								boolLabels: { true: "Activo", false: "Inactivo" },
								width: 2,
								canFilter: true,
								canSort: true,
								canPrint: true,
								canExcel: true,
								sortKey: null,
							},
							{
								label: "Adjunto",
								key: "uri",
								dataPosition: "center",
								format: "boolean",
								boolLabels: { true: "Si" },
								width: 1,
								canFilter: true,
								canSort: true,
								canPrint: true,
								canExcel: true,
								sortKey: null,
							},
						]}
						totalRows={filteredCount}
						defaultParams={defaultParams}
						handlerTable={handleButtom}
						dataHandler={handlerData}
					/>
				</div>
			</Modal.Content>
			<Modal.Actions className={styles.modalHeader}>
				<Button className={styles.negativeButton} onClick={onClose}>
					Atrás
				</Button>
				<Button className={styles.positiveButton} onClick={handlerSaved}>
					Guardar
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

Hashtag.propTypes = {
	onClose: PropTypes.func,
	dispatch: PropTypes.func,
};
export default connect()(Hashtag);
